import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../../contexts/ThemeContext'
import { useI18n } from '../../i18n/I18nContext'
import { authCopy } from '../../i18n/authCopy'

export default function ThemeToggle() {
    const { isDark, setTheme } = useTheme()
    const { language } = useI18n()
    const label = authCopy[language][isDark ? 'lightTheme' : 'darkTheme']
    const Icon = isDark ? Sun : Moon
    return (
        <button type="button" onClick={() => setTheme(isDark ? 'light' : 'dark')}
            aria-label={label} title={label}
            className="inline-flex size-[44px] shrink-0 items-center justify-center rounded-control border-2 border-[var(--dhtn-border)] text-[var(--dhtn-text-muted)] hover:border-[var(--dhtn-border-strong)] hover:text-[var(--dhtn-text)] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--dhtn-text)]">
            <Icon size={19} strokeWidth={2} aria-hidden="true" />
        </button>
    )
}
